// extracted by mini-css-extract-plugin
export var cost = "TagsLayout-module--cost--a7143";
export var costHint = "TagsLayout-module--costHint--02bc8";
export var costSum = "TagsLayout-module--costSum--dd27f";
export var fadeInAnimation = "TagsLayout-module--fadeInAnimation--e8e43";
export var tagsTitle = "TagsLayout-module--tagsTitle--66f51";
export var wrapper = "TagsLayout-module--wrapper--73b9b";